import React, { useState, useEffect} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Input from "@material-ui/core/Input";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Preloader from "../../../components/Preloader/Preloader";
const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
		maxHeight:"100%",
		overflow: "auto"
	},
	root: {
		"& .MuiTextField-root": {
			width: "100%",
		},
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
}));

export default function UpdatePackageSalesUserRole(props) {
    const [userPackageSalesNav, setUserPackageSalesNav] = useState([]);
    const [PackageSalesNav, setPackageSalesNav] = useState([]);
	const getUserPackageSalesNav = () => {
		//get data for warehouse/location dropdown
		// const form_data = {
		// 	position_id:  props.position_id
		// }
		const formData = new FormData();
		formData.append("position_id", props.position_id);
		const apiUrl = process.env.REACT_APP_API_URL+'getuserpackagesalesnav';
		axios.post(apiUrl, formData, {
			headers: {
				"Content-Type": "multipart/form-data"
			}
		}).then((res) => {
            setUserPackageSalesNav(res.data.result.userpackagesnav);
		});
		// axios.post(apiUrl, { form_data }).then((res) => {
        //     setUserPackageSalesNav(res.data.result.userpackagesnav);
		// });	
	};
	const getPackageSalesNav = () => {
		//get data for warehouse/location dropdown
		const apiUrl = process.env.REACT_APP_API_URL+'getpackagesalesnav';
		axios.post(apiUrl).then((res) => {
			setPackageSalesNav(res.data.result.navs);
		});
	};

	const isChecked = (id) => {
		if(props.position_id != ""){
			return userPackageSalesNav.includes(id);
		}else{
			return false;
		}
	}
	useEffect(() => {
		getUserPackageSalesNav();
        getPackageSalesNav();
    }, []);
	return (
		<div>
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<h4>Package Sales</h4>
				</Grid>
				{PackageSalesNav ? PackageSalesNav.map((nav)=>{
					return(<Grid item xs={6} key={nav.id}>
						<FormControlLabel
							control={
								<Checkbox
								defaultChecked={isChecked(nav.id.toString())}
								name={"ps"+nav.id}
								value={String(nav.id)}
								color="primary"
								/>
							}
							label={nav.nav_name}
							/>
						</Grid>
					)
				}): <Preloader />}
			</Grid>
		</div>
	);
}
